module.exports = __webpack_public_path__ + "img/tarjeta.f90728c0.svg";